import React from 'react';
import { useNavigate } from 'react-router-native';

import { PortalPaths } from '../../interfaces/portal-paths.enum';
import { ChangePasswordModal } from '../../organisms/change-password-modal/change-password-modal';
import { PortalLayout } from '../../templates/portal-layout/portal-layout';

export interface AccountPageProps {}

export const AccountPage = () => {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  return (
    <PortalLayout selectedPage={PortalPaths.Account} title="Account">
      <ChangePasswordModal goBack={goBack} />
    </PortalLayout>
  );
};
